import { QueryClient } from '@tanstack/react-query';
import axios from 'axios';

export const queryClientSingleton = new QueryClient({
  defaultOptions: {
    // React Query's network detection is flaky. Always run queries / mutations regardless of network status
    queries: {
      networkMode: 'always',
      // Smart retry: avoid client errors (4xx) but retry server/network issues
      // We already retry on 401s in the axios interceptor so we don't need to retry them here
      retry: (failureCount, error) => {
        if (axios.isAxiosError(error) && error.response?.status) {
          const status = error.response.status;
          if (status >= 400 && status < 500 && status !== 408 && status !== 429) {
            return false;
          }
        }
        return failureCount < 3;
      }
    },
    mutations: {
      networkMode: 'always'
    }
  }
});
